import { FormikHelpers } from 'formik';

import { ConfiguracaoGeral } from '../types';

import { useFormMutation } from 'mutations/useFormMutation';

export function useMutateConfiguracaoGeral() {
    const { mutate, isLoading } = useFormMutation();

    const handleSubmit = (formData: ConfiguracaoGeral, formik: FormikHelpers<ConfiguracaoGeral>) => {
        mutate({
            formData,
            formik,
            preventRedirect: true,
            url: '/gestao/revendedordesconto',
        });
    };

    return { handleSubmit, isLoading };
}
